export const BaseCdnUrl = 'https://assets.xemplo.com';
export const CdnArea = {
  Image: 'common/images',
  Script: 'common/scripts',
  Storybook: 'common/storybook',
} as const;

export type CdnArea = (typeof CdnArea)[keyof typeof CdnArea];
